<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 09:45:01
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 11:33:56
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\registerMerchant.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='app-container' :style="{ height: height }">
        <!-- 头部进度栏 -->
        <div class="real-wrapper">
            <div class="real-step">
                <div :class="{ 'real-step-item': true, active: step >= index }" v-for="(item, index) in stepList"
                    :key="index" @click="changeStep(index)">
                    <van-icon class="icons" v-if="index < stepList.length - 1"
                        :color="step >= index ? '#c9221d' : '#D8D8D8'" name="arrow" />
                    <div class="item-icon df jcc aic">
                        <img v-if="!item.isOver" :src="item.icon" mode="widthFix" />
                        <img v-else src="../../assets/true.png" mode="widthFix" />
                    </div>
                    <div class="item-name">{{ item.label }}</div>
                </div>
            </div>
        </div>

        <!-- 中间内容 -->
        <div class="content-box">
            <Step01 v-if="step === 0" :cityList="cityList" @giveup="giveupPopup = true" @confirm="next"
                :merchartInfo="merchartInfo" />
            <Step02 v-if="step === 1" @giveup="giveupPopup = true" @confirm="next" :merchartInfo="merchartInfo" @goProstep="goProstep" />
            <Step03 v-if="step === 2" @giveup="giveupPopup = true" @confirm="next" :merchartInfo="merchartInfo"  @goProstep="goProstep" />
            <Step04 v-if="step === 3" @giveup="giveupPopup = true" @confirm="next" :merchartInfo="merchartInfo"  @goProstep="goProstep" />
            <Step05 v-if="step === 4" @giveup="giveupPopup = true" @confirm="next" :merchartInfo="merchartInfo"  @goProstep="goProstep"
                @showAgreement="showAgreement = true" />
        </div>
        <div class="agreement-box" v-if="showAgreement">
            <Agreement @close="showAgreement = false" :businessInformation="merchartInfo" />
        </div>

        <!-- 放弃注册弹窗 -->
        <van-popup v-model="giveupPopup" round :style="{ width: '300px' }">
            <div class="prompt">
                <div class="prompt-txt">
                    您是否确定清除当前填写的所有内容，放弃注册？
                </div>
                <div class="btns">
                    <div class="close btn" @click="giveUp">确认放弃</div>
                    <div class="continue btn" @click="giveupPopup = false">继续注册</div>
                </div>
            </div>
        </van-popup>

    </div>
</template>

<script>
import { Toast } from 'vant';
import step01 from "../../assets/step-01.png";
import step02 from "../../assets/step-02.png";
import step03 from "../../assets/step-03.png";
import step04 from "../../assets/step-04.png";
import step05 from "../../assets/step-05.png";

import Step01 from "./components/step01.vue"
import Step02 from "./components/step02.vue"
import Step03 from "./components/step03.vue"
import Step04 from "./components/step04.vue"
import Step05 from "./components/step05.vue"
import Agreement from "./components/agreement.vue"

import { getAddressCode } from "@/api/index"
export default {
    name: '',
    components: {
        Step01,
        Step02,
        Step03,
        Step04,
        Step05,
        Agreement
    },
    props: {},
    computed: {},
    watch: {},
    mounted() { },
    data() {
        return {
            merchartInfo: {},
            step: 0, // 当前进度下标
            stepList: [{
                label: "基本信息", // 名字
                icon: step01, // 图标
                isOver: false, // 当前信息是否完成
            },
            {
                label: "证件信息",
                icon: step02,
                isOver: false,
            },
            {
                label: "结算信息",
                icon: step03,
                isOver: false,
            },
            {
                label: "其他信息",
                icon: step04,
                isOver: false,
            },
            {
                label: "APP注册",
                icon: step05,
                isOver: false,
            },
            ],

            // 省市区 code列表
            cityList: [],

            // 放弃注册弹窗
            giveupPopup: false,

            showAgreement: false,
            height: "",
        };
    },
    async created() {
        this.height = document.documentElement.clientHeight + "px"
        // 获取进件信息
        this.merchartInfo = this.$store.state.merchartInfo
        getAddressCode().then(res => {
            this.cityList = this.arrayhandle(res.data)
        })

        // 测试 
        this.merchartInfo = JSON.parse(localStorage.getItem('merchartInfo'))
    },
    methods: {
        // 点击头部进度栏时
        changeStep(index) {
            if (index >= this.step) return;

            for (let idx = index; idx < this.stepList.length; idx++) {
                this.$set(this.stepList[idx], "isOver", false);
            }
            this.step = index;
        },
        giveUp() {
            Toast.loading({
                message: '放弃中...',
                forbidClick: true,
            });
            location.replace("/oneClickRegister")
        },
        // 上一步
        goProstep(val) {
            console.log("上一步", val);
            this.step = val.step - 1
        },

        next(val) {
            // 基本信息
            this.$store.commit('setMerchart', val.data)
            this.merchartInfo = val.data
            Toast.clear()
            console.log(this.merchartInfo);
            console.log("====");
            console.log(this.$store.state.merchartInfo);
            if (val.step === 0) {
                // console.log("基本信息传过来的值：", val);
                // console.log("vuex的值：", this.$store.state.merchartInfo);
            }
            if (val.step == 1) {
                // console.log("证件信息传值：", val, "当前页面merCharts:", this.merchartInfo, "=====", this.$store.state.merchartInfo);
                this.merchartInfo.accountCardName = this.merchartInfo.trueName
            }
            if (val.step == 2) {
                // console.log("结算信息传值：", val, "当前页面merCharts:", this.merchartInfo, "=====", this.$store.state.merchartInfo);
            }
            if (val.step == 3) {
                // console.log("其他接口传值：", val, "当前页面merCharts:", this.merchartInfo, "=====", this.$store.state.merchartInfo);
            }
            if (val.step == 4) {
                // console.log("app注册传值：", val, "当前页面merCharts:", this.merchartInfo, "=====", this.$store.state.merchartInfo);
                Toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                });
                location.replace("/registerComplete")
                return
            }

            this.$set(this.stepList[this.step], "isOver", true);
            this.step++
        },
        // 省市区 数据格式化
        arrayhandle(arr) {
            arr.map(item => {
                // 对数据进行处理
                item.children = item.districts
                // 递归调用
                if (item.districts && item.districts.length) {
                    this.arrayhandle(item.districts)
                }
            })
            return arr;
        },
        mergeObj() {

        }

    },
};
</script>

<style scoped lang="scss">
.app-container {
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
}

.real-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 70px;
    // padding: 0;
    box-sizing: border-box;
    z-index: 9999;

    .real-step {
        display: flex;
        width: 100%;
        background-color: #ffffff;
        margin-bottom: 10px;

        &-item {
            flex: 1;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 10px 0;
            position: relative;

            &.active {
                .item-icon {
                    background: linear-gradient(180deg, #fb4747 0%, #c9221d 100%);
                }

                .item-name {
                    color: #333333;
                }
            }

            >.icons {
                color: #9a5c12;
                position: absolute;
                top: 22px;
                right: -8px;
            }

            .item-icon {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                background-color: #d8d8d8;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 13px;
                }
            }

            .item-name {
                color: #a5a7ad;
                font-size: 12px;
            }
        }
    }
}

.content-box {
    height: calc(100vh - 80px);
    flex: 1;
    box-sizing: border-box;
    overflow-y: auto;
    margin-top: 80px;


    ::v-deep .step-box {

        .step-content {
            padding: 25px 13px;
            background-color: #fff;
            box-sizing: border-box;

            .step-title {
                font-weight: 600;
                font-size: 20px;
                color: #333333;

                .red {
                    color: #D32537;
                }
            }

            .tips {
                font-size: 10px;
                color: #D32537;
            }
        }
    }
}

.prompt {
    padding: 25px 20px;

    .prompt-txt {
        font-weight: 600;
        margin-bottom: 25px;
        text-align: center;
        font-size: 16px;
        color: #333333;
    }

    .close-btn {
        width: 238px;
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        background: #D32537;
        border-radius: 23px;
    }

    .btns {
        display: flex;
        justify-content: space-between;

        .btn {
            width: 110px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            border-radius: 26px;
        }

        .close {
            font-size: 16px;
            color: #D32537;
            background-color: #FDF1F1;
        }

        .continue {
            font-size: 16px;
            color: #FFFFFF;
            background-color: #CE292F;
        }
    }
}


.agreement-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>
